<template>
    <div class="phone-login-page">
        <mt-header fixed title="手机号登录" style="background:#ffffff;color:#262626;">
            <router-link to="/loginPage" slot="left">
                <mt-button icon="back"></mt-button>
            </router-link>
        </mt-header>

        <div class="main-section">
            <h2>欢迎登录果师兄</h2>
            <div class="box input regionNum" @click="show">
              <span>{{country}}</span>
              <span>
                +{{code}}
                <div class="arrow"></div>
              </span>
            </div>
            <div class="box input phone">
              <input type="text" placeholder="请输入手机号" v-model="phone">
            </div>
            <div class="box input code">
              <input type="text" placeholder="请输入验证码" v-model="password">
              <span v-show="sms_show" @click.stop="getSms">获取验证码</span>
              <span class="count_down"  v-show="!sms_show">{{count}}秒后重发</span>
            </div>
            <div class="box login" @click="login" :class="{'login_able':goSubmit}">登录</div>
        </div>
        <AwesomePicker  ref="pickers" :data="picker.slot" :textConfirm="picker.textConfirm"  :colorConfirm="picker.colorConfirm" :colorCancel="picker.colorCancel" @confirm="handlePickerConfirm"></AwesomePicker >
    </div>

</template>

<script>
import axios from 'axios';
import picker from 'vue-3d-picker';
import AwesomePicker  from '../assets/lib/awesome-picker'
import { Popup,Indicator,Spinner,MessageBox,Picker } from 'mint-ui';
export default {
    name:"login",
    metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
    },
    data(){
        return{
            picker:{
                slot:[],
                textConfirm:"完成",
                colorConfirm:"#3189FF",
                colorCancel:"#3189FF"
            },
            password:"",
            phone:"",
            popupVisible:false,
            country:"中国大陆",
            code:"86",
            code_options:"",
            country_options:"",
            sms_show:true,//是否能获取验证码
            smsAble:false,
            count:"59",
            slots:[
                {
                flex: 1,
                values: [],
                className: 'slot1',
                textAlign: 'center'
                },
            ],
            countryCodes:[],
            goSubmit:false,
            country_arr:[]
        }
    },
    methods:{
        show() {
            this.$refs.pickers.show();
        },
        handlePickerConfirm(item){
            this.country = this.country_arr[item[0].index].country;
            this.code = this.country_arr[item[0].index].code;
            this.validInput();

        },
        onValuesChange(picker, values) {
            let arr =  values.join().split(" ");
            this.code_options = arr[0].replace("+","");
            this.country_options = arr[arr.length-1];

        },
        validInput(){
            this.phone = this.phone.replace(/\s+/g, "");
            if(this.code != 86){
                var reg_phone = /^\d{6,}$/;
            }else{
                var reg_phone = /^1\d{10}$/;
            }
            if(reg_phone.test(this.phone)){
                this.smsAble = true;
            }else{
                this.smsAble = false;
            }

            if(this.phone && reg_phone.test(this.phone) && this.password){

                this.goSubmit = true;
            }else{
                this.goSubmit = false;

            }
        },
        chooseCode(){
            if(!this.code_options || !this.country_options){
                return
            }
            this.code = this.code_options;
            this.country = this.country_options;
            this.popupVisible = false;
        },
        getCountryCodes(){
            var vm = this;
            this.$store.dispatch("getCountryCodes").then((res)=>{
                var result = res.data;
                if(result.code == 0){
                    let countryCodes = result.res;
                    vm.country_arr = countryCodes;
                    let arr1 = [];
                    for(let i=0;i<countryCodes.length;i++){
                        let code = `<span class="country_code">+${countryCodes[i].code}</span><span class="country_name">${countryCodes[i].country}</span>`;
                        arr1.push(code)
                    }
                    vm.picker.slot.push(arr1)

                }
            })
        },
        getSms(){
            if(!this.smsAble){
                return
            }
            var vm = this;
            this.count = 59;
            if(this.code != 86){
                var reg_phone = /^\d{6,}$/;
            }else{
                var reg_phone = /^1\d{10}$/;
            }
            if(!vm.phone.replace(/\s+/g, "")){
                this.$toastlj("请输入手机号码")
                return
            }
            if(!reg_phone.test(vm.phone.replace(/\s+/g, ""))){
                this.$toastlj("请输入正确的手机号码")
                return
            }

            let info = {
               'phone':vm.phone,
               'country_code':vm.code,
               'type':1,
               'app_id':window.config.appid,

            }
            this.$store.dispatch("getSms",info).then((res)=>{
                var result = res.data;
                if(result.code == 0){
                     vm.countDown();
                     vm.sms_show = false;
                }


            })
        },
        countDown(){
            let vm = this;
            let interval = setInterval(function(){
                vm.count = vm.count -1;
                if(vm.count == 0){
                    vm.sms_show = true;
                    window.clearInterval(interval);
                }
            },1000)
        },
        goback(){
            localStorage.removeItem("login_first");

            let authorization = localStorage.authorization;
            if(!authorization || authorization == 'undefined' || authorization == 'null' ){
                this.$router.push({name:"home"})
            }else{
                this.$router.push({name:"my"})
            }
        },
        login(){

            if(!this.goSubmit){
                return
            }

            var vm = this;
            if(this.code != 86){
                var reg_phone = /^\d{6,}$/;
            }else{
                var reg_phone = /^1\d{10}$/;
            }
            if(!vm.phone.replace(/\s+/g, "")){
                this.$toastlj("请输入手机号码")
                Indicator.close();
                return
            }
            if(!reg_phone.test(vm.phone.replace(/\s+/g, ""))){
                this.$toastlj("请输入正确的手机号码")
                Indicator.close();
                return
            }
            if(!vm.password.replace(/\s+/g, "")){
                this.$toastlj("请输入验证码")
                return
            }
            Indicator.open('登录中...');
            let info = {
               'phone':vm.phone.replace(/\s+/g, ""),
               'country_code':vm.code.replace(/\s+/g, ""),
               'type':1,
               'app_id':window.config.appid,
               'password':vm.password.replace(/\s+/g, ""),
               'source':5
            };
            this.$store.dispatch("login",info).then((res)=>{
                var result = res.data;

                localStorage.removeItem("login_first");
                if(result.code == 0){
                    let token = result.res.token;
                    let userinfo = result.res.userinfo;
                    Indicator.close();
                    localStorage.login_phone = vm.phone.replace(/\s+/g, "");
                    localStorage.access_token = token.access_token;
                    localStorage.expire_time = token.expire_time*1000;
                    localStorage.refresh_expire_time = token.refresh_expire_time;
                    localStorage.refresh_token = token.refresh_token;
                    localStorage.kxuid = userinfo.kxuid
                    localStorage.nickname = userinfo.user_nickname
                    localStorage.bind_phone = userinfo.user_bind_phone
                    localStorage.email = userinfo.user_bind_email

                    let nextPath = vm.$route.query.path;
                    const redirectUrl = vm.$route.query.redirectUrl;
                    if(nextPath){
                        vm.$router.push({name:nextPath})
                    }
                    else if(redirectUrl){
                      vm.$router.push({path: redirectUrl})
                    }
                    else{
                        vm.$router.push({name:"my"})
                    }

                }else if(result.code == 1300){
                    // MessageBox('提示', '验证码错误');
                    vm.$toastlj('验证码错误')
                    Indicator.close();

                }else{
                    vm.$toastlj(result.message)

                }
            })
        }
    },

    created(){
        this.getCountryCodes();
    },
    mounted(){
        Indicator.close();
    },
    watch: {
        phone: function(value) {
            this.validInput()
        },
        password: function (value) {
            this.validInput()
        }
    },
    components:{
        Picker,
        Popup,
        Indicator,
        picker,
        AwesomePicker
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/PhoneLogin.vue